var _g, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgExcel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "excel",
    xmlns: "http://www.w3.org/2000/svg",
    width: 78.67,
    height: 82.443,
    viewBox: "0 0 78.67 82.443",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_544",
    "data-name": "Group 544",
    transform: "translate(9.525 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_54",
    "data-name": "Subtraction 54",
    d: "M60.9,82.443H8.244A8.254,8.254,0,0,1,0,74.2V64.832H28.486a5.006,5.006,0,0,0,5-5V21.313a5.006,5.006,0,0,0-5-5H0V8.244A8.253,8.253,0,0,1,8.244,0H47.87L69.145,21.275V74.2A8.254,8.254,0,0,1,60.9,82.443ZM53.012,53.372v5.153H63.69V53.372Zm-8.588,0v5.153H49.6V53.372ZM53.012,44v5.153H63.69V44Zm-8.588,0v5.153H49.6V44Zm8.588-9.374v5.153H63.69V34.626Zm-8.588,0v5.153H49.6V34.626Zm.8-29.274V23.988h18.6Z",
    transform: "translate(0 0)",
    fill: "#d6d6d6"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Exclusion_2",
    "data-name": "Exclusion 2",
    d: "M32.2,36.613H5a5.006,5.006,0,0,1-5-5V5A5.006,5.006,0,0,1,5,0H32.2a5.006,5.006,0,0,1,5,5V31.613A5.005,5.005,0,0,1,32.2,36.613ZM17.285,22.527v0l4.4,8.915h7.273L21.451,18.167,28.76,5.108h-7.2l-4.273,8.754L13.011,5.108H5.828l7.291,13.059L5.631,31.444h7.254l4.4-8.915Z",
    transform: "translate(0 22.199)",
    fill: "#209a0d"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcel);
export default __webpack_public_path__ + "static/media/excel.f6ba081efa58c26463fd856142c71b12.svg";
export { ForwardRef as ReactComponent };